import { h } from 'preact';
import { accessNested, sortObjectByOrder } from 'utils/utils';
import Store from 'store/store';
import { geoFromIP } from 'utils/bolt/geo';
import * as BaseComp from 'components/bolt/footer/footer.js';
// import s from 'components/bolt/footer/footer.sss';

let userRegion;
const getUserRegion = (() => {
	let promise;
	return (onCreate) => {
		if (!promise) {
			promise = geoFromIP();
			promise.then(onCreate);
		}
		return promise;
	};
})();

export default class Footer extends BaseComp.default {

	sortAndFilterItems(items) {
		const ageGateEnabled = accessNested(Store.get(), 'appData.options.ageGate', false);
		const isOfAge = accessNested(Store.get(), 'client.ofAge', null);

		return sortObjectByOrder(items, (item, key) => ({ key, ...item })).filter(item => {
			const ageGateShowOnly = item.ageGateShowOnly || null;
			const ageKnown = typeof isOfAge === 'boolean';

			if (ageGateShowOnly) {
				// ageGateShowOnly = 0 : only show when age gate enabled but age not known yet
				if (+ageGateShowOnly === 0 && (ageGateEnabled && ageKnown || !ageGateEnabled)) {
					return false;
				}
				// ageGateShowOnly = 1 : age over the limit only (or age gate not set)
				if (+ageGateShowOnly === 1 && ageGateEnabled && !isOfAge) {
					return false;
				}
				// ageGateShowOnly = 2 : age under the limit only
				if (+ageGateShowOnly === 2 && (isOfAge || !ageKnown)) {
					return false;
				}
			}
			if ((item.excludeFromShowtimes && this.showtimesFooter) || (item.showtimesOnly && !this.showtimesFooter)) {
				return false;
			}
			if (item.userRegion) {
				// If we don't have the region yet, start getting it and then rerender once we have it
				getUserRegion(geo => {
					userRegion = geo?.countryCode;
					this.forceUpdate();
				});
				const valid = item.userRegion.split(',').map(r => r.trim().toLowerCase()).includes(userRegion);
				if (!valid) {
					return false;
				}
			}
			return true;
		});
	}

}
